import ActionEventResponse from './ActionEventResponse';

export default ActionEventResponse;
